<template>
  <div>
    <div class="flex flex-row" :key="`rankhand-${participantId}-${cards.length}-${remainingCards.length}`">
      <div v-for="(item, index) in cards" :key="`card-${participantId}-${index}`">
        <Card :card="item" :show="true" :isExtraCard="isExtraCard(item)" />
      </div>
      <div v-for="(item, index) in remainingCards" :key="`remainingcard-${participantId}-${index}`">
        <Card :card="item" :show="false" :isExtraCard="isExtraCard(item)" />
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
import { Card as CardType } from "@models/Card";
import Card from "@/components/Card.vue";

interface Props {
  cards: CardType[];
  extraCard?: CardType;
  participantId: string;
  cardCount: number;
}
const props = defineProps<Props>();

const remainingCards = Array.from({ length: props.cardCount - props.cards.length }, () => ({
  value: "",
  suit: "",
}));

const isExtraCard = (card: CardType) => {
  return props.extraCard ? extraCard.value === card.value && extraCard.suit === card.suit : false;
};
</script>
